export const getFilters = async (store) => {
  const requests = {
    advertiser_id: store.requestGet('Advertisers/getList'),
    offer_id: store.requestGet('Offers/getOffersList'),
    landing_id: store.requestGet('Offers/getLandingsList'),
    app_id: store.requestGet('PWA/getAppsList'),
    bayer_id: store.requestGet(`Traffics/Influence/getBayersList`),
    inf_traffic_id: store.requestGet(`traffics/influence/blogger/list`),
    link_id: store.requestGet(`traffics/influence/source/list`),
    app_service_id: store.requestGet('Apps/getServicesList'),
    brand_id: store.requestGet('Brands/getBrands'),
    country_id: store.requestGet('Countries/getList'),
  };

  const results = await Promise.all(Object.values(requests));
  const keys = Object.keys(requests);
  const data = Object.fromEntries(keys.map((key, i) => [key, results[i]]));

  // Обробка ролей
  if (
    store.roles.includes(6) ||
    store.roles.includes(19) ||
    store.roles.includes(13) ||
    store.roles.includes(32) ||
    store.roles.includes(38)
  ) {
    data.bayer_id = [];
  }

  const filtersObj = {
    ...data,
    app_type: [
      {name: 'PWA', id: 'pwa'},
      {name: 'IOS', id: 'ios'},
      {name: 'Android', id: 'android'},
    ],
    state: [
      {name: 'С Данными', id: 'with_data'},
      {name: 'С Лидами', id: 'leads'},
      {name: 'Без Лидов', id: 'without_leads'},
      {name: 'С Регистрациями', id: 'reg'},
      {name: 'Без Регистраций', id: 'without_reg'},
      {name: 'С Квалификациями', id: 'cpa'},
      {name: 'Без Квалификаций', id: 'without_cpa'},
      {name: 'Активно', id: 'active'},
      {name: 'Не активно', id: 'inactive'},
      {name: 'Недавно Создано', id: 'recently_created'},
    ],
    traffic_type: [
      {name: 'Приложения ', id: 'pwa'},
      {name: 'Схемы', id: 'telegram'},
    ],
    country_id: data.country_id.map(({name, id, flag}) => ({name, id, flag})),
  };

  const excludedKeys = ['app_type', 'state', 'traffic_type', 'country_id'];

  Object.entries(filtersObj).forEach(([key, value]) => {
    if (
      !excludedKeys.includes(key) &&
      Array.isArray(value) &&
      value.every((v) => v?.id !== undefined)
    ) {
      value.sort((a, b) => {
        const aId = isNaN(a.id) ? a.id : Number(a.id);
        const bId = isNaN(b.id) ? b.id : Number(b.id);
        return bId > aId ? 1 : bId < aId ? -1 : 0;
      });
    }
  });

  return filtersObj;
};
